import { IScreenByType } from "./../../hooks/useMedia";
import { FieldTypes } from "../fields/types";
import { IDimension } from "./types";

const commonData: IDimension = { h: 2, w: 4, x: 0, y: 0, minH: 2, maxH: 2, minW: 1, maxW: 4 };

export type ICommonFields = {
    [key in FieldTypes]: IDimension;
};

const commonFields: ICommonFields = {
    [FieldTypes.SINGLE_LINE_TEXT]: commonData,
    [FieldTypes.INPUT_MULTI_LINE_TEXT]: { ...commonData, minW: 2 , maxH: 3},
    [FieldTypes.PASSWORD]: commonData,
    [FieldTypes.NAME]: { ...commonData, minW: 2 },
    [FieldTypes.PHONE]: { ...commonData, minW: 2 },
    [FieldTypes.NUMBER]: commonData,
    [FieldTypes.DATE]: { ...commonData, minW: 2 },
    [FieldTypes.STAR_RATING]: { ...commonData, h: 97, minH: 97, maxH: 97 },
    [FieldTypes.URL]: commonData,
    [FieldTypes.ADDRESS]: { ...commonData, minW: 2 },
    [FieldTypes.EMAIL]: commonData,
    [FieldTypes.SCALE_RATING]: { ...commonData, minW: 3 },
    [FieldTypes.HEADEING]: commonData,
    [FieldTypes.TERMS]: { ...commonData, minW: 2 },
    [FieldTypes.DESCRIPTION]: commonData,
    [FieldTypes.PRICE]: { ...commonData, minW: 1 },
    [FieldTypes.TIME]: commonData,
    [FieldTypes.CHECKBOX]: commonData,
    [FieldTypes.MAP]: commonData,
    [FieldTypes.CUSTOM_HTML]: commonData,
    [FieldTypes.RADIO]: commonData,
    [FieldTypes.SIGNATURE]: commonData,
    [FieldTypes.FILE_UPLOAD]: { ...commonData, minW: 3 },
    [FieldTypes.DROPDOWN]: commonData,
    [FieldTypes.TIMEZONE]: { ...commonData, minW: 2 },
    [FieldTypes.PROMOCODE]: commonData,
    [FieldTypes.PAYMENT_METHOD]: commonData,
};

export const layoutInitials: { [key in IScreenByType]: ICommonFields } = {
    [IScreenByType.DESKTOP_BIG]: {
        ...commonFields,
        [FieldTypes.NAME]: { ...commonFields[FieldTypes.NAME], minW: 2 },
        [FieldTypes.PHONE]: { ...commonFields[FieldTypes.PHONE], minW: 1 },
        [FieldTypes.DATE]: { ...commonFields[FieldTypes.DATE], minW: 2 },
        [FieldTypes.URL]: { ...commonFields[FieldTypes.URL], minW: 2 },
        [FieldTypes.INPUT_MULTI_LINE_TEXT]: { ...commonFields[FieldTypes.INPUT_MULTI_LINE_TEXT], minW: 1 },
        [FieldTypes.PRICE]: { ...commonData, minW: 1 },
    },
    [IScreenByType.DESKTOP]: {
        ...commonFields,
        [FieldTypes.NAME]: { ...commonFields[FieldTypes.NAME], minW: 2 },
        [FieldTypes.DATE]: { ...commonFields[FieldTypes.DATE], minW: 2 },
        [FieldTypes.URL]: { ...commonFields[FieldTypes.URL], minW: 2 },
        [FieldTypes.ADDRESS]: { ...commonFields[FieldTypes.ADDRESS], minW: 3 },
        [FieldTypes.INPUT_MULTI_LINE_TEXT]: { ...commonFields[FieldTypes.INPUT_MULTI_LINE_TEXT], minW: 2 },
        [FieldTypes.PRICE]: { ...commonData, minW: 1 },
    },
    [IScreenByType.DESKTOP_MIDDLE]: {
        ...commonFields,
        [FieldTypes.NAME]: { ...commonFields[FieldTypes.NAME], minW: 3 },
        [FieldTypes.DATE]: { ...commonFields[FieldTypes.DATE], minW: 2 },
        [FieldTypes.URL]: { ...commonFields[FieldTypes.URL], minW: 2 },
        [FieldTypes.ADDRESS]: { ...commonFields[FieldTypes.ADDRESS], minW: 3 },
        [FieldTypes.INPUT_MULTI_LINE_TEXT]: { ...commonFields[FieldTypes.INPUT_MULTI_LINE_TEXT], minW: 2 },
        [FieldTypes.PRICE]: { ...commonData, minW: 2 },
        [FieldTypes.TIME]: { ...commonData, minW: 2 },
    },
    [IScreenByType.DESKTOP_SMALL]: {
        ...commonFields,
        [FieldTypes.NAME]: { ...commonFields[FieldTypes.NAME], minW: 3 },
        [FieldTypes.DATE]: { ...commonFields[FieldTypes.DATE], minW: 2 },
        [FieldTypes.URL]: { ...commonFields[FieldTypes.URL], minW: 2 },
        [FieldTypes.ADDRESS]: { ...commonFields[FieldTypes.ADDRESS], minW: 3 },
        [FieldTypes.INPUT_MULTI_LINE_TEXT]: { ...commonFields[FieldTypes.INPUT_MULTI_LINE_TEXT], minW: 2 },
        [FieldTypes.PRICE]: { ...commonData, minW: 2 },
        [FieldTypes.TIME]: { ...commonData, minW: 2 },
    },
    [IScreenByType.MOBILE]: {
        ...commonFields,
        [FieldTypes.NAME]: { ...commonFields[FieldTypes.NAME], minW: 3 },
        [FieldTypes.DATE]: { ...commonFields[FieldTypes.DATE], minW: 2 },
        [FieldTypes.URL]: { ...commonFields[FieldTypes.URL], minW: 2 },
        [FieldTypes.ADDRESS]: { ...commonFields[FieldTypes.ADDRESS], minW: 3 },
        [FieldTypes.PRICE]: { ...commonData, minW: 2 },
        [FieldTypes.TIME]: { ...commonData, minW: 2 },
    },
};
